import React from 'react'
import { IconSVGType } from '../../types/icons'

/**
 * @param {IconSVGType} props
 * @param {string} props.className (Optional) - Class name of the component.
 * @param {object} props.style (Optional) - Styles to customize the look & feel of the component.
 */
const CloudUploadIcon = (props: IconSVGType) => {
  return (
    <svg
      width='25'
      height='24'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_79_2982)'>
        <path
          d='M5.15 10.04C5.83 6.59 8.86 4 12.5 4C15.39 4 17.9 5.64 19.15 8.04C22.16 8.36 24.5 10.91 24.5 14C24.5 17.31 21.81 20 18.5 20H5.5C2.74 20 0.5 17.76 0.5 15C0.5 12.36 2.55 10.22 5.15 10.04ZM10.5 13V17H14.5V13H17.5L12.5 8L7.5 13H10.5Z'
          fill='black'
          fillOpacity='0.4'
        />
      </g>
      <defs>
        <clipPath id='clip0_79_2982'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='matrix(-1 0 0 1 24.5 0)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CloudUploadIcon
